import { createAction } from 'redux-actions';

import types from './types';

const setLoading = createAction(types.SET_LOADING);
const loadNotifyMeList = createAction(types.LOAD_NOTIFY_ME_LIST);
const addToNotifyMeList = createAction(types.ADD_TO_NOTIFY_ME_LIST);
const removeFromNotifyMeList = createAction(types.REMOVE_FROM_NOTIFY_ME_LIST);
const setNotifyMeList = createAction(types.SET_NOTIFY_ME_LIST);

export default {
    setLoading,
    loadNotifyMeList,
    removeFromNotifyMeList,
    setNotifyMeList,
    addToNotifyMeList,
};
